export default __webpack_public_path__ + "static/media/onlinefoodordering.0cd97da6.png";